<template>
  <v-card class="mb-4 pa-4">
    <p class="text-h6 secondary--text">
      {{ handleVisibility ? "Descripción de OBS" : "Especificaciones de OBS" }}
    </p>
    
    <p class=" primary--text mb-0">Listado de OBS</p>
    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="5"
      class="elevation-0"
      hide-default-footer
    >
      <template v-slot:[`item.correlativo`]="{ item }">
        {{ items.map((col) => col.id).indexOf(item.id) + 1 }}
      </template>
      <template v-slot:[`item.unidad_medida`]="{ item }">
        {{ item.presentacion?.nombre }}
      </template>
      <template v-slot:[`item.obs`]="{ item }">
        {{ item.proceso_obs?.obs?.codigo }} -
        {{ item.proceso_obs?.obs?.nombre }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "DescripcionObsComponent",
  data: () => ({
    headers: [
      {
        text: "Correlativo",
        value: "correlativo",
        align: "center",
      },
      {
        text: "Especificación",
        value: "especificacion",
        align: "center",
      },
      {
        text: "Unidad de medida",
        value: "unidad_medida",
        align: "center",
      },
      {
        text: "Total($)",
        value: "total_sub_proceso",
        align: "center",
      },
      {
        text: "OBS",
        value: "obs",
        align: "center",
      },
    ],
    items: [
      {
        id: 1,
        correlativo: 1,
        codigo_mercancia: "11001651",
        mercancia: "Lapiceros azules",
        unidad_medida: "Unidad",
        cantidad: 100,
        monto: 70,
      },
      {
        id: 2,
        correlativo: 2,
        codigo_mercancia: "13123136",
        mercancia: "Resmas de papel",
        unidad_medida: "Unidad",
        cantidad: 200,
        monto: 47,
      },
      {
        id: 3,
        correlativo: 3,
        codigo_mercancia: "15616516",
        mercancia: "Microondas",
        unidad_medida: "Unidad",
        cantidad: 3,
        monto: 250,
      },
    ],
  }),
  computed: {
    ...mapState("seguimientoOrden", ["seguimientoContrato"]),
    handleVisibility() {
      if (this.seguimientoContrato) {
        const { contrato } = this.seguimientoContrato;
        return contrato?.id_tipo_contrato === 1;
      } else return false;
    },
  },
  methods: {
    async getListadoObs() {
      const { data, status } =
        await this.services.ContratoService.getContratoEspecificaciones(
          this.$route.params.idContrato
        );
      if (status == 200) {
        this.items = data;
      }
    },
  },
  created() {
    this.getListadoObs();
  },
};
</script>
